"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimString = exports.titleCase = exports.isString = exports.isJSON = exports.generateRandomString = exports.fullName = void 0;
const lodash_1 = require("lodash");
const random_util_1 = require("./random.util");
/**
 * Converts a string to title case.
 *
 * @param text - The input string.
 * @returns The string converted to title case.
 */
function titleCase(text) {
    return trimString(text
        .toLowerCase() // First, convert the entire string to lowercase
        .replace(/\b\w/g, (char) => char.toUpperCase())); // Then, capitalize the first letter of each word
}
exports.titleCase = titleCase;
/**
 * Generates a random string based on the provided seed, length, and character set.
 *
 * @param seed - The seed value used for generating the random string.
 * @param length - The length of the random string to be generated.
 * @param charSet - The character set from which the random string will be composed.
 * @returns The randomly generated string.
 */
function generateRandomString(seed, length, charSet) {
    const generator = (0, random_util_1.randomNumber)(charSet.length - 1, 0, seed);
    let text = '';
    for (let index = 0; index < length; index++) {
        text += charSet[generator()];
    }
    return text;
}
exports.generateRandomString = generateRandomString;
/**
 * Generate a full name by combining first name and last name.
 *
 * @param firstName - The first name (optional).
 * @param lastName - The last name (optional).
 * @returns The full name as a string.
 */
function fullName(firstName, lastName) {
    return trimString(`${(0, lodash_1.capitalize)(firstName ?? '')} ${(0, lodash_1.capitalize)(lastName ?? '')}`);
}
exports.fullName = fullName;
/**
 * Trims leading and trailing whitespace from a string.
 *
 * @param text - The string to trim.
 * @returns The trimmed string, or `null` if the input string is empty or `null`.
 */
function trimString(text) {
    return text?.length && text.trim().length ? text.trim() : null;
}
exports.trimString = trimString;
/**
 * Checks if the given data is a valid JSON string.
 *
 * @param data - The data to be checked.
 * @returns A boolean indicating whether the data is a valid JSON string.
 */
function isJSON(data) {
    try {
        if (!isString(data))
            return false;
        JSON.parse(data);
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.isJSON = isJSON;
const STRING = 'string';
/**
 * Checks if a value is a string.
 *
 * @param value - The value to check.
 * @returns Returns `true` if the value is a string, `false` otherwise.
 */
function isString(value) {
    return typeof value === STRING;
}
exports.isString = isString;
//# sourceMappingURL=string.util.js.map